import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { Input, Label } from 'semantic-ui-react'

export function LabeledInput({
  label,
  labelProps,
  defaultValue,
  value,
  onChange,
  inputProps,
  className,
}) {
  const handleChange = (e) => {
    onChange(e.target.value)
  }

  return (
    <Input className={classNames(className, 'labeled large')}>
      <Label basic {...labelProps}>
        {label}
      </Label>
      <input defaultValue={defaultValue} value={value} onChange={handleChange} {...inputProps} />
    </Input>
  )
}

LabeledInput.propTypes = {
  label: PropTypes.node.isRequired,
  defaultValue: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  inputProps: PropTypes.object,
  labelProps: PropTypes.object,
  className: PropTypes.string,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/LabeledInput/index.js